export default {
  vessel: { name: 'Vessel', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  heatExchanger: { name: 'Heat Exchanger', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  piping: { name: 'Piping', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  mufle: { name: 'Mufle', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  radiantTube: { name: 'Radiant Tube', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  otherEquipment: { name: 'Other Equipment', desc: 'Ada beberapa alasan membangun situs lorem ipsum dolor sit amet.' },
  fabricationOf: 'Fabrikasi',
  readMore: 'BACA SELENGKAPNYA',
};
